import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import { infoSnack, successSnack, errorSnack } from "../snackbar/snackbarSlice";
// thunkAPI.dispatch(successSnack('Fetched Users'));
// thunkAPI.dispatch(infoSnack('Look at these Users'));
// thunkAPI.dispatch(errorSnack('User error'));
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchSuppliers = createAsyncThunk(
  "suppliers/fetchSuppliers",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/suppliers${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setSuppliersAmount(response.headers["x-total-count"]));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching suppliers list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreSuppliers = createAsyncThunk(
  "suppliers/fetchMoreSuppliers",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/suppliers${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setSuppliersAmount(response.headers["x-total-count"]));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const filterSuppliers = createAsyncThunk(
  "suppliers/filterSuppliers",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/suppliers${args.query}`,
        config
      );
      return await response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchSupplierByID = createAsyncThunk(
  "suppliers/fetchSupplierByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/suppliers/${args.id}`,
        config
      );

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching supplier data"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deleteSupplier = createAsyncThunk(
  "suppliers/deleteSupplier",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.delete(
        `${baseURL}/v1/admin/suppliers/${args.id}`,
        config
      );
      thunkAPI.dispatch(successSnack("Supplier deleted"));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deleting supplier"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateSupplier = createAsyncThunk(
  "suppliers/updateSupplier",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.patch(
        `${baseURL}/v1/admin/suppliers/${args.id}`,
        args.updatedSupplier,
        config
      );
      thunkAPI.dispatch(
        fetchSuppliers({ token: args.token, query: "" })
      );
      thunkAPI.dispatch(successSnack("Supplier updated successfully"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating supplier"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createSupplier = createAsyncThunk(
  "suppliers/createSupplier",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.post(
        `${baseURL}/v1/admin/suppliers`,
        args.supplier,
        config
      );
      thunkAPI.dispatch(
        fetchSuppliers({ token: args.token, query: "" })
      );
      thunkAPI.dispatch(successSnack("Supplier created successfully"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating supplier"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreSuppliers(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const suppliersSlice = createSlice({
  name: "suppliers",
  initialState: {
    supplier: {},
    suppliersList: [],
    suppliersFilter: [],
    loading: "idle",
    message: "",
    error: "",
    editing: false,
    suppliersAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setSuppliersAmount: (state, action) => {
      state.suppliersAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSuppliers.pending, (state) => {
      state.suppliersList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchSuppliers.fulfilled, (state, { payload }) => {
      state.suppliersList = payload;
      state.suppliersFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchSuppliers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreSuppliers.fulfilled, (state, { payload }) => {
      state.error = "";
      state.suppliersList = state.suppliersList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreSuppliers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.suppliersList = state.suppliersList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(filterSuppliers.pending, (state) => {
      state.suppliersFilter = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(filterSuppliers.fulfilled, (state, { payload }) => {
      state.suppliersFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(filterSuppliers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchSupplierByID.pending, (state) => {
      state.supplier = {};
      state.loading = "loading";
    });
    builder.addCase(fetchSupplierByID.fulfilled, (state, { payload }) => {
      state.editing = true;
      state.supplier = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchSupplierByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(deleteSupplier.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(deleteSupplier.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(deleteSupplier.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updateSupplier.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(updateSupplier.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(updateSupplier.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createSupplier.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(createSupplier.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createSupplier.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const { setLastQuery, setSuppliersAmount } = suppliersSlice.actions;

export const selectSuppliers = createSelector(
  (state) => ({
    suppliers: state.suppliers,
    loading: state.suppliers.loading,
    error: state.suppliers.error,
    editing: state.suppliers.editing,
    supplier: state.suppliers.supplier,
    suppliersList: state.suppliers.suppliersList,
    suppliersAmount: state.suppliers.suppliersAmount,
    lastQuery: state.suppliers.lastQuery,
  }),
  (state) => state
);
export default suppliersSlice.reducer;
